import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/debarras-cave-grenier-garage/PageClient.jsx");
